import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Chip from '@material-ui/core/Chip'
import Avatar from '@material-ui/core/Avatar'
import GridList from '@material-ui/core/GridList'
import Button from '@material-ui/core/Button'
import NearMe from '@material-ui/icons/NearMe'
import Mouse from '@material-ui/icons/Mouse'
import MyLocation from '@material-ui/icons/MyLocation'
import Tooltip from './Tooltip'
import isEmptyObject from '../utility/isEmptyObject'

const decimals = 4

const styles = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-around',
    overflow: 'hidden'
  },
  gridList: {
    flexWrap: 'nowrap'
  },
  chip: {
    margin: theme.spacing.unit
  }
})

const Location = ({ classes, bounds, center, handleClick, mouse }) => {
  if (
    !bounds ||
    !center ||
    !mouse ||
      isEmptyObject(bounds) ||
      isEmptyObject(center) ||
      isEmptyObject(mouse) ||
    center.length
  ) {
    return null
  }

  return (
    <div className={classes.root}>
      <GridList className={classes.gridList} cellHeight={'auto'} cols={2}>
          <Button size='small'><Mouse />{`${mouse.lat.toFixed(decimals)}, ${mouse.lng.toFixed(decimals)}`}</Button>
          <Button size='small' onClick={handleClick}><MyLocation />{`${center.lat.toFixed(decimals)}, ${center.lng.toFixed(decimals)}`}</Button>
      </GridList>
    </div>
  )
  // return (
  //   <div>
  //     {mouse &&
  //     <Tooltip id={'mouse'} title={'mouse'}>
  //       <Chip
  //         className={classes.chip}
  //         avatar={<Avatar>M</Avatar>}
  //         onClick={handleClick}
  //         value='mouse'
  //         label={`${mouse.lat.toFixed(decimals)}, ${mouse.lng.toFixed(
  //           decimals
  //         )}`}
  //         />
  //       </Tooltip>
  //     }
  //     <Tooltip id={'sw'} title={'southwest'}>
  //       <Chip
  //         className={classes.chip}
  //         avatar={<Avatar>SW</Avatar>}
  //         onClick={handleClick}
  //         value='southwest'
  //         label={`${bounds._sw.lat.toFixed(decimals)}, ${bounds._sw.lng.toFixed(
  //           decimals
  //         )}`}
  //       />
  //     </Tooltip>
  //     <Tooltip id={'c'} title={'center'}>
  //       <Chip
  //         className={classes.chip}
  //         avatar={<Avatar>C</Avatar>}
  //         onClick={handleClick}
  //         label={`${center.lat.toFixed(decimals)}, ${center.lng.toFixed(
  //           decimals
  //         )}`}
  //       />
  //     </Tooltip>
  //     <Tooltip id={'ne'} title={'northeast'}>
  //       <Chip
  //         className={classes.chip}
  //         avatar={<Avatar>NE</Avatar>}
  //         onClick={handleClick}
  //         label={`${bounds._ne.lat.toFixed(decimals)}, ${bounds._ne.lng.toFixed(
  //           decimals
  //         )}`}
  //       />
  //     </Tooltip>
  //   </div>
  // )
}

export default withStyles(styles)(Location)



// WEBPACK FOOTER //
// ./src/components/Location.js